import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import { Center } from '@/components/ui/center'
import { Spinner } from '@/components/ui/spinner'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import UserDetail from '@/modules/profile/UserDetail'
import { selectAllSubAccounts } from '@/redux/slices/subAccountSlice'
import { useAppSelector } from '@/redux/store'
import { UserRole } from '@/typings/domain'
import { Stack, useLocalSearchParams, useRouter } from 'expo-router'
import { useMemo } from 'react'

export default function UserDetailPage() {
  const router = useRouter()
  const { id } = useLocalSearchParams<{ id: string }>()
  const headerLeftItems = useWebBackButton('/profile/users')
  const subAccounts = useAppSelector(selectAllSubAccounts)
  const currentUser = useAppSelector(state => state.currentUser.user)
  const isOwnerOrAdmin = useAppSelector(state => state.currentUser.isOwnerOrAdmin)

  const { user, isCurrentUser, isOwner } = useMemo(() => {
    const foundUser = subAccounts.find(u => u.id === id)
    return {
      user: foundUser,
      isCurrentUser: foundUser?.id === currentUser?.id,
      isOwner: foundUser?.role === UserRole.Owner,
    }
  }, [subAccounts, id, currentUser])

  if (!user) {
    return (
      <Center className="h-[50vh]">
        <Spinner />
      </Center>
    )
  }

  const handleRemoveSuccess = () => {
    router.back()
  }

  const canEdit = isOwnerOrAdmin && !isCurrentUser && !isOwner

  return (
    <>
      <Stack.Screen
        options={{
          title: isOwner ? '拥有者' : isCurrentUser ? '我的信息' : '成员详情',
          ...buildScreenHeaderItems({ left: headerLeftItems }),
        }}
      />
      <UserDetail
        user={user}
        isCurrentUser={isCurrentUser}
        isOwner={isOwner}
        canEdit={canEdit}
        onRemoveSuccess={handleRemoveSuccess}
      />
    </>
  )
}
